const initial = [] ;

export default function chartZoomReducer(state = initial, action) {
  switch (action.type) {
    case "SET_CHART_ZOOM":
      // upsert the entry by id
      const idx = state.findIndex(z => z.id === action.payload.id);
      if (idx >= 0) {
        const next = [...state];
        next[idx] = action.payload;
        return next;
      }
      return [...state, action.payload];

    case "CLEAR_CHART_ZOOM":
      return initial;

    default:
      return state;
  }
}
